export default "__VITE_ASSET__2U7w88sT__"